import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { SvgIconType } from '@integration-app/react';
import { ActionBar } from '../Row/ActionBar';
import { FieldPropertiesModal } from '.';
export function FieldActionBar({ onDelete, name, schema, isRequired, propertiesSchema, properties, onPropertiesChange, onRequiredChange, }) {
    const [openProperties, setOpenProperties] = useState(false);
    const toggleOpenProperties = () => setOpenProperties((v) => !v);
    const showConfigButton = Boolean(schema && propertiesSchema && onPropertiesChange);
    const buttons = [];
    if (showConfigButton) {
        buttons.push(_jsx(ActionBar.GenericButton, { onClick: toggleOpenProperties, iconType: SvgIconType.Settings, tooltip: 'Properties' }, 'onProperties'));
    }
    if (onDelete) {
        buttons.push(_jsx(ActionBar.DeleteButton, { onClick: onDelete }, 'onDelete'));
    }
    return buttons.length ? (_jsxs(_Fragment, { children: [_jsx(ActionBar, { children: buttons }), showConfigButton && (_jsx(FieldPropertiesModal, { open: openProperties, onClose: toggleOpenProperties, name: name, schema: schema, propertiesSchema: propertiesSchema, onPropertiesChange: onPropertiesChange, propertiesValue: properties, onRequiredChange: onRequiredChange, isRequired: isRequired }))] })) : null;
}
//# sourceMappingURL=ActionBar.js.map